import {SidebarMenuMain} from './SidebarMenuMain'

const SidebarMenu = () => {
  return (
    <div className='app-sidebar-menu flex-column-fluid overflow-visible'>
      <div id='kt_app_sidebar_menu_wrapper' className='app-sidebar-wrapper my-3'>
        <div className='menu menu-column menu-rounded px-2' id='kt_app_sidebar_menu'>
          <SidebarMenuMain />
        </div>
      </div>
    </div>
  )
}

export {SidebarMenu}
